module.exports = {
    "level1": {
    "name": "Nome reale",
    "idcard": "Tipo di documento:",
    "address": "Indirizzo attuale",
    "bank_number": "Numero di conto bancario",
    "wc": "Conferma",
    "name_nodata": "Il nome non può essere vuoto",
    "id_card_nodata": "Il numero del documento non può essere vuoto",
    "address_nodata": "L'indirizzo non può essere vuoto",
    "bank_number_nodata": "Il numero di conto bancario non può essere vuoto",
    "input-username": "Inserisci il nome reale",
    "zjhm": "Numero del documento",
    "input-idcard": "Inserisci il numero del documento",
    "input-address": "Inserisci l'indirizzo",
    "zjlx": "Tipo di documento",
    "qxzzjlx": "Seleziona il tipo di documento",
    "sfz": "Carta d'identità",
    "hz": "Passaporto",
    "jsz": "Patente di guida",
    "lxz": "Certificato di studio all'estero",
    "zfbzh": "Account Alipay",
    "qsrzfbzh": "Inserisci l'account Alipay",
    "khh": "Banca di apertura",
    "qsrkhh": "Inserisci la banca di apertura",
    "yhkh": "Numero di conto bancario",
    "qsryhkh": "Inserisci il numero di conto bancario",
    "zfzh": "Account di pagamento",
    "qxzzfzh": "Seleziona l'account di pagamento",
    "gjlb": "Elenco dei paesi",
    "qxzgjlb": "Seleziona paese/regione"
  },
  "my": {
    "bindphone": "Collega telefono",
    "gqrcode": "Scansiona il codice QR qui sotto o inserisci il codice promozionale per confermare la registrazione",
    "mqrcode": "Il mio codice QR",
    "as": "Impostazioni",
    "pc": "Verifica di base",
    "ac": "Verifica avanzata",
    "smrz": "Verifica dell'identità",
    "mnzh":"Conto demo",

"mnzhcg": "Conto demo creato con successo!",
    "sfyz": "Verifica dell'identità",
    "mm": "I miei fondi",
    "ms": "Voglio condividere",
    "me": "I miei guadagni",
    "zsr": "Guadagno totale",
    "mp": "La mia promozione",
    "yqhy": "Invita amici",
    "ar": "Registro account",
    "hc": "Centro assistenza",
    "nodata": "Nessun dato disponibile",
    "med": "Dettagli dei guadagni",
    "aes": "Guadagno totale (USDT)",
    "one": "Primo livello",
    "two": "Secondo livello",
    "three": "Terzo livello",
    "four": "Quarto livello",
    "ones": "Numero di primo livello",
    "twos": "Numero di secondo livello",
    "threes": "Numero di terzo livello",
    "fours": "Numero di quarto livello",
    "promotion": "Numero di promozioni",
    "customers": "I miei guadagni",
    "total": "Totale (ieri)",
    "usdt": "USDT",
    "wdzc": "I miei asset",
    "wdzc1": "I miei asset",
    "wyfx": "Voglio condividere",
    "wdsy": "I miei guadagni",
    "wdtg": "La mia promozione",
    "zhjl": "Registro account",
    "fbjl": "Registro valute legali",
    "zxkf": "Contatta il servizio clienti",
    "wdxx": "I miei messaggi"
  },
  "footer": {
    "home": "Home",
    "quotation": "Mercato",
    "currency": "Scambio di criptovalute",
    "lever": "Trading di contratti",
    "assets": "Asset",
    "my": "Il mio",
    "lc": "Interessi sui fondi"
  },

   "index": {
    "wdzc": "I miei asset (USDT)",
    "xsbk": "Da leggere per i principianti",
    "dlhkck": "Accedi per visualizzare",
    "dl": "Accedi per visualizzare",
    "zxkf": "Contatta il servizio clienti",
    "function": "Servizi",
    "legal": "Trading di valute legali",
    "legaltxt": "Acquista asset digitali con valute legali",
    "levertxt": "Investimenti multipli rispetto ai fondi originali",
    "c2c": "Trading C2C",
    "c2ctxt": "Trading bidirezionale per copertura",
    "increase": "Classifica delle variazioni",
    "innovate": "Zona innovativa",
    "myshop": "Il mio negozio",
    "order": "Gestione ordini",
    "myc2c": "Il mio trading C2C",
    "usercenter": "Centro personale",
    "myshare": "Il mio link di condivisione",
    "releasec2c": "Pubblica C2C",
    "language": "Cambia lingua",
    "security": "Centro sicurezza",
    "pay": "Metodi di pagamento",
    "bindaddress": "Collega indirizzo di prelievo",
    "address": "Indirizzo di prelievo",
    "aboutus": "Chi siamo",
    "logout": "Disconnetti",
    "vol": "Volume 24H",
    "jc": "Scambia JC con BEAU",
    "kjcb": "Ricarica rapida",
    "zcbz": "BTC, USDT..."
  },
  "transaction": {
    "buy": "Acquista",
    "sell": "Vendi",
    "pwd": "Password di trading",
    "inputpass": "Inserisci la password di trading",
    "inputnum": "Inserisci la quantità",
    "limit": "Prezzo limite",
    "avaiable": "Disponibile",
    "turnover": "Volume di trading",
    "handicap": "Mercato",
    "number": "Quantità",
    "nonumber": "Quantità non completata",
    "numbered": "Quantità completata",
    "price": "Prezzo",
    "marketprice": "Prezzo di mercato",
    "cancel": "Annulla",
    "total": "Trading totale",
    "time": "Tempo",
    "nomore": "Nessun altro dato disponibile",
    "nodata": "Nessun record disponibile",
    "getmore": "Carica di più",
    "mycommission": "Le mie commissioni",
    "currentbuy": "Ordine attuale (acquisto)",
    "currentsell": "Ordine attuale (vendita)",
    "his": "Ordini storici (completati)",
    "currency": "Tipo di valuta",
    "option": "Operazione",
    "wtime": "Tempo di completamento",
    "wnumber": "Quantità completata",
    "wprice": "Prezzo completato"
  },
  "mk": {
    "high": "Alto",
    "low": "Basso",
    "vol": "Volume 24H",
    "newPrice": "Prezzo attuale",
    "product": "Prodotto",
    "name": "Nome",
    "rank": "Classifica delle variazioni"
  },
  "deals": {
    "issue_time": "Data di emissione",
    "issue_number": "Quantità emessa",
    "white_book": "Whitepaper",
    "weburl": "Sito ufficiale",
    "video_url": "Video introduttivo",
    "introduction": "Introduzione",
    "onhand": "1 mano equivale a",
    "position": "Posizione attuale",
    "leverorder": "Ordine con leva",
    "leverposition": "Posizione con leva",
    "inputprice": "Inserisci prezzo",
    "inputmul": "Inserisci moltiplicatore",
    "selectmul": "Seleziona moltiplicatore",
    "onehand": "1 mano equivale a",
    "hand": "Numero di mani",
    "marketval": "Valore di mercato del contratto",
    "bond": "Margine",
    "service": "Commissione di servizio",
    "balance": "Saldo",
    "type": "Tipo",
    "risk": "Tasso di rischio",
    "total": "Guadagno/perdita totale della posizione:",
    "onekey": "Chiusura con un clic",
    "makemore": "(Long)",
    "makeless": "(Short)",
    "current": "Ordine attuale",
    "all": "Tutti",
    "weing": "In attesa di approvazione",
    "tding": "In corso",
    "ping": "Chiusura in corso",
    "pied": "Chiuso",
    "ceiled": "Ordine annullato",
    "weprice": "Prezzo dell'ordine",
    "oprice": "Prezzo di apertura",
    "nowprice": "Prezzo attuale",
    "zyprice": "Prezzo di take profit",
    "zsprice": "Prezzo di stop loss",
    "canbond": "Margine disponibile",
    "optime": "Tempo di apertura",
    "pgtime": "Tempo di chiusura",
    "znum": "Quantità equivalente",
    "gprice": "Commissione overnight",
    "pcang": "Chiusura",
    "revoke": "Annulla ordine",
    "fee": "Commissione",
    "you": "Fai trading al miglior prezzo attuale"
  },
  "assets": {
    "bzxz": "Selezione della valuta",
    "copy": "Copia",
    "currency": "Criptovaluta",
    "lever": "Contratti",
    "legal": "Valuta legale",
    "curAccount": "Account di criptovaluta",
    "total": "Equivalente totale (USDT)",
    "leverAccount": "Account di contratti",
    "legalAccount": "Account di valuta legale",
    "avaiable": "Disponibile",
    "lock": "Bloccato",
    "conversion": "Equivalente",
    "exact": "Account di trading",
    "transfer": "Trasferimento",
    "num": "Quantità",
    "time": "Tempo",
    "record": "Registro",
    "caidata": "Registro finanziario",
    "from": "Da",
    "to": "A",
    "transnum": "Quantità trasferita",
    "all": "Tutti",
    "canuse": "Disponibile",
    "pmin": "Inserisci la quantità minima da trasferire",
    "cmoney": "Ricarica",
    "tmoney": "Prelievo",
    "caddress": "Indirizzo di ricarica",
    "copyaddress": "Copia indirizzo",
    "a01": "Non inviare alcun asset non",
    "a02": "alla valuta sopra,",
    "a03": "altrimenti gli asset non saranno recuperabili.",
    "a04": "Le ricariche supportano solo il metodo 'simple send', l'utilizzo di altri metodi per la ricarica non accreditati temporaneamente, ti preghiamo di comprendere.",
    "a05": "Dopo aver ricaricato all'indirizzo sopra, è necessaria la conferma di tutti i nodi della rete, 1 conferma della rete per l'accredito, 6 conferme della rete per il prelievo.",
    "a06": "Importo minimo di ricarica:",
    "a07": "Le ricariche inferiori all'importo minimo non saranno accreditate e non saranno rimborsabili.",
    "a08": "Il tuo indirizzo di ricarica non cambierà frequentemente e può essere utilizzato per ricariche ripetute; se ci sono modifiche, ti informeremo tramite annunci sul sito o email.",
    "a09": "Assicurati di controllare che il computer e il browser siano sicuri, per prevenire modifiche o perdite di informazioni.",
    "taddress": "Indirizzo di prelievo",
    "taddressm": "Inserisci l'indirizzo di prelievo",
    "padd": "Inserisci o premi a lungo per incollare l'indirizzo",
    "rate": "Commissione",
    "dnum": "Quantità accreditata",
    "more": "Carica di più",
    "nodata": "Nessun record disponibile",
    "search": "Cerca tipo di valuta",
    "yczc": "Nascondi asset pari a 0"
  },


  "td": {
    "drecord": "Registro ordini",
    "orecord": "Registro ordini completati",
    "filter": "Filtra",
    "tdtype": "Tipo di transazione",
    "buy": "Acquista",
    "sell": "Vendi",
    "wantbuy": "Richiesta di acquisto",
    "dstatus": "Stato dell'ordine",
    "nofinish": "Non completato",
    "finished": "Completato",
    "ceiled": "Annullato",
    "payed": "Pagato",
    "waitPay": "In attesa di pagamento",
    "reset": "Reimposta",
    "confirm": "Conferma",
    "time": "Tempo",
    "num": "Quantità",
    "tdtotal": "Importo totale della transazione",
    "call": "Contatta l'altra parte",
    "buyer": "Acquirente",
    "seller": "Venditore",
    "Sprice": "Prezzo unitario",
    "price": "Prezzo",
    "ptime": "Tempo di ordinazione",
    "cnum": "Numero di riferimento",
    "tdceil": "Annulla transazione",
    "sureReceive": "Conferma ricezione del pagamento",
    "conPay": "Conferma pagamento",
    "ppay": "Si prega di effettuare il pagamento",
    "paynext": "Si prega di pagare al seguente account",
    "tdPrice": "Prezzo unitario della transazione",
    "tdNum": "Quantità della transazione",
    "payInfo": "Informazioni sul pagamento",
    "accountInfo": "Informazioni sull'account",
    "receiver": "Beneficiario",
    "open": "Banca di apertura",
    "pcnum": "Si prega di inserire il numero di riferimento al momento del pagamento",
    "imPay": "Ho effettuato il pagamento, clicca per confermare",
    "tdAttion": "Avviso di transazione",
    "odCeil": "Annulla ordine",
    "at01": "Il tuo pagamento andrà direttamente all'account del venditore. Gli asset digitali venduti dal venditore durante la transazione sono protetti dalla piattaforma.",
    "at02": "Si prega di completare il pagamento entro il tempo stabilito e di cliccare su 'Ho effettuato il pagamento'. Dopo che il venditore ha confermato la ricezione, il sistema trasferirà gli asset digitali al tuo account.",
    "at03": "Se l'acquirente annulla l'ordine 3 volte nello stesso giorno, verrà limitata la funzione di acquisto per quel giorno.",
    "sureImpay": "Si prega di confermare di aver pagato il venditore",
    "badClick": "Clic malevoli porteranno al blocco diretto dell'account",
    "notpay": "Non ho ancora pagato l'altra parte",
    "sureDpay": "Si prega di confermare che l'acquirente ti ha pagato",
    "sureCeil": "Conferma annullamento della transazione",
    "notCeil": "Se hai già pagato il venditore, non annullare la transazione",
    "dover": "L'ordine è completato, non è possibile visualizzare le informazioni di pagamento",
    "cover": "L'ordine è stato annullato, non è possibile visualizzare le informazioni di pagamento",
    "payFast": "Si prega di pagare il venditore il prima possibile dopo la conferma del pagamento",
    "payClick": "Se hai già trasferito il pagamento al venditore, assicurati di cliccare sul pulsante 'Ho effettuato il pagamento' in basso a destra, altrimenti potresti subire perdite di fondi.",
    "pwait": "Si prega di attendere il pagamento dell'acquirente",
    "pwd": "Password di trading",
    "ppwd": "Inserisci la password di trading",
    "sure": "Conferma",
    "alipay": "Alipay",
    "wechat": "WeChat",
    "bank": "Conto bancario",
    "realName": "Nome reale",
    "knum": "Numero della carta",
    "pprice": "Inserisci il prezzo unitario",
    "pnum": "Inserisci la quantità",
    "min": "Quantità minima",
    "pmin": "Inserisci la quantità minima",
    "max": "Quantità massima",
    "pmax": "Inserisci la quantità massima",
    "buyNum": "Quantità da acquistare",
    "currency": "Tipo di valuta",
    "pmethod": "Seleziona il metodo di pagamento",
    "choose": "Seleziona",
    "mysells": "Le mie vendite",
    "mybuys": "Le mie richieste di acquisto",
    "pcoin": "Seleziona l'unità di valuta"
  },
  "fat": {
    "mybuy": "Voglio comprare",
    "mysell": "Voglio vendere",
    "ceil": "Annulla",
    "buy": "Acquista",
    "sell": "Vendi",
    "forsell": "Richiesta di vendita",
    "forbuy": "Richiesta di acquisto",
    "price": "Prezzo unitario",
    "bprice": "Acquista a prezzo",
    "bnum": "Acquista per quantità",
    "pbtotal": "Inserisci l'importo totale in valuta legale da acquistare",
    "pstotal": "Inserisci l'importo totale in valuta legale da vendere",
    "pbnum": "Inserisci la quantità da acquistare",
    "psnum": "Inserisci la quantità da vendere",
    "allbuy": "Acquista tutto",
    "allsell": "Vendi tutto",
    "limit": "Limite",
    "tdtotal": "Importo totale della transazione",
    "autoceil": "Annullamento automatico",
    "num": "Quantità",
    "submit": "Ordina",
    "pwd": "Password di trading",
    "ppwd": "Inserisci la password di trading",
    "sure": "Conferma ordine",
    "reTime": "Commerciante certificato | Data di registrazione",
    "release": "Pubblica",
    "allOrder": "Ordini totali",
    "dayOrder": "Ordini completati in 30 giorni",
    "overOrder": "Ordini completati",
    "rate": "Tasso di completamento",
    "auPhone": "Verifica telefono",
    "auName": "Verifica identità",
    "auHigh": "Verifica avanzata",
    "sellLine": "Vendita online",
    "buyLine": "Acquisto online",
    "myshop": "Il mio negozio",
    "mybalance": "Saldo del commerciante"
  },
  "auth": {
    "bh": "Rifiutato",
    "bhr": "La tua richiesta è stata rifiutata per i seguenti motivi:",
    "mycenter": "Centro personale",
    "test": "Verifica dell'identità",
    "gotest": "Vai a verificare",
    "testing": "In fase di revisione",
    "tested": "Verificato",
    "t1": "Dopo la verifica, puoi aumentare il limite di prelievo",
    "t2": "Dopo la verifica, puoi effettuare transazioni C2C",
    "t3": "Dopo la verifica, puoi effettuare transazioni in valuta legale",
    "name": "Nome",
    "account": "Account",
    "number": "Numero del documento",
    "pname": "Inserisci il nome",
    "pnum": "Inserisci il numero del documento",
    "id_card_face": "Si prega di caricare il fronte della carta d'identità",
    "id_card_back": "Si prega di caricare il retro della carta d'identità",
    "upimg": "Si prega di caricare il fronte e il retro del documento, oltre a una foto con il documento in mano.",
    "updata": "Invia",
    "updata_again": "Reinvia"
  },
  "code": {
    "mycode": "Il mio codice promozionale",
    "code": "Codice promozionale",
    "qrcode": "Scansiona il codice QR sopra o inserisci il codice promozionale per confermare la registrazione",
    "notice": "Annuncio",
    "about": "Notizie correlate"
  },
  "safe": {
    "title": "Sicurezza dell'account",
    "center": "Centro sicurezza",
    "qchc": "Pulisci cache",
    "yysz": "Impostazioni lingua",
    "ssms": "Modalità scura",
    "gywm": "Chi siamo",
    "lgpwd": "Password di accesso",
    "tkmm": "Password di prelievo",
    "paypwd": "Password di pagamento",
    "resetpwd": "Modifica password",
    "paccount": "Inserisci numero di telefono o email",
    "next": "Passo successivo",
    "reset": "Modifica",
    "stest": "Verifica di sicurezza",
    "ceil": "Annulla",
    "pcode": "Inserisci codice di verifica",
    "send": "Invia",
    "sure": "Conferma",
    "newPwd": "Reimposta password",
    "len": "La password deve avere 6-20 caratteri",
    "ppwd": "Inserisci password",
    "reppwd": "Reinserisci password",
    "repwd": "Reimposta password",
    "zpwd": "Password di trading"
  },

   "met": {
    "add": "Aggiungi metodo",
    "open": "Nome della banca di apertura",
    "bank": "Numero di conto bancario",
    "realname": "Nome reale",
    "alipay": "Account Alipay",
    "wename": "Nickname WeChat",
    "wechat": "Account WeChat",
    "save": "Salva",
    "popen": "Inserisci il nome della banca di apertura",
    "pbank": "Inserisci il numero di conto della banca di apertura",
    "pname": "Inserisci il nome reale",
    "palipay": "Inserisci l'account Alipay",
    "pwename": "Inserisci il nickname WeChat",
    "pweaccount": "Inserisci l'account WeChat"
  },
  "ads": {
    "tas": "Indirizzo di prelievo",
    "address": "Indirizzo",
    "noads": "Non hai ancora indirizzi",
    "adds": "Indirizzi",
    "padd": "Inserisci o incolla l'indirizzo di prelievo",
    "remark": "Nota",
    "cel": "Elimina"
  },
  "call": {
    "callme": "Contattaci",
    "Privacy": "Politica sulla privacy"
  },
  "jc": {
    "title": "Piattaforma di scambio JC punti per BEAU",
    "bind": "Collega account",
    "balance": "Saldo JC",
    "cannum": "Numero di JC disponibile:",
    "new": "Ultimo prezzo BEAU:",
    "exnum": "Quantità da scambiare:",
    "pnum": "Inserisci la quantità di JC",
    "canex": "Numero di BEAU convertibile: ≈",
    "exnow": "Scambia ora",
    "record": "Registro di scambio",
    "exprice": "Prezzo di scambio:",
    "extime": "Tempo di scambio",
    "not": "Numero di punti disponibili insufficiente",
    "usenum": "Numero di JC da utilizzare",
    "paccount": "Inserisci account",
    "ppwd": "Inserisci password",
    "gotd": "Vai a fare trading"
  },
  "lg": {
    "welcome": "Ciao! Benvenuto nel login",
    "hsa": "Hai già un account?",
    "symncz":'Utilizzo di un conto demo',
    "lgs": "Accedi",
    "lgbt": "Accedi",
    "lgtel": "Accesso tramite telefono",
    "lgeml": "Accesso tramite email",
    "paccount": "Numero di telefono o email",
    "ppwd": "Inserisci password",
    "ppwd2": "Conferma password",
    "pcode": "Inserisci codice di verifica",
    "qsryqm": "Inserisci codice di invito",
    "mepwd": "Ricorda password",
    "noaccount": "Non hai ancora un account?",
    "qregister": "Registrati",
    "register": "Registrati",
    "phregister": "Registrazione tramite telefono",
    "emregister": "Registrazione tramite email",
    "noset": "Non può essere modificato dopo la registrazione",
    "pphone": "Inserisci numero di telefono",
    "next": "Passo successivo",
    "have": "Hai già un account?",
    "ceil": "Annulla",
    "msgtest": "Verifica SMS",
    "send": "Ottieni codice di verifica",
    "sure": "Conferma",
    "email": "Inserisci indirizzo email",
    "emtest": "Verifica email",
    "scode": "Invia codice di verifica",
    "pemcode": "Inserisci codice di verifica",
    "ppcode": "Inserisci codice di verifica del telefono",
    "ftpwd": "Hai dimenticato la password?",
    "ftpwds": "Dimentica password",
    "ptext": "Inserisci numero di telefono o email",
    "safetest": "Verifica di sicurezza",
    "sjh": "Numero di telefono",
    "yzm": "Codice di verifica",
    "mm": "Password",
    "qrmm": "Conferma password",
    "mmcd": "La password deve avere una lunghezza di 8-12 caratteri",
    "language": "Cambia lingua",
    "kjzc": "Contatta il servizio clienti per una registrazione rapida",
    "kjzc1": "Non ricevi il codice di verifica?",
    "kjzc2": "Registrazione rapida",
    "wyzx": "Ho preso visione",
    "qtxyxzh": "Avviso: Si prega di fornire un indirizzo email o numero di telefono valido per recuperare la password"
  },
 


 "gjrz": {
    "title": "Verifica avanzata",
    "t1": "1. Supporta immagini JPG, JPEG o PNG inferiori a 8M.",
    "t2": "2. Le foto del documento devono essere chiare, non sono consentite modifiche o coperture, devono mostrare chiaramente il volto, il numero del documento e il nome.",
    "t3": "3. Le foto devono essere senza cappello, si consiglia di non truccarsi, il viso deve essere chiaramente visibile e le braccia completamente esposte.",
    "t4": "Conferma",
    "bh": "Rifiutato",
    "shz": "In fase di revisione",
    "shtg": "Revisione approvata",
    "nyrzcg": "Hai completato con successo la verifica",
    "sczjz": "Carica foto del documento",
    "sczjzmz": "Carica foto frontale del documento",
    "sczjbmz": "Carica foto posteriore del documento",
    "scgrqmz": "Carica foto con il documento in mano"
  },
  "chongzhi": {
    "title": "Ricarica",
    "cbjl": "Registro ricariche",
    "t1": "Quantità",
    "t2": "Inserisci la quantità",
    "t3": "Descrizione della ricevuta (facoltativo)",
    "t4": "Inserisci la descrizione",
    "t5": "Immagine della ricevuta",
    "t6": "Conferma",
    "t7": "Nome della rete",
    "t8": "Codice QR",
    "t9": "Salva codice QR",
    "t10": "Indirizzo di ricarica",
    "t11": "Copia",
    "zy": "Attenzione",
    "tips1": "Non inviare alcun asset non appartenente a questa valuta all'indirizzo sopra, altrimenti gli asset non saranno recuperabili.",
    "tips2": "1. Compatibilità del portafoglio/piano: ovvero supporto per questa rete; se la piattaforma di destinazione non supporta la tua rete di prelievo, gli asset non saranno recuperabili.",
    "tips3": "2. La rete di ricarica e la piattaforma di destinazione devono essere coerenti; se scegli un indirizzo di destinazione su Ethereum ma ricarichi tramite la rete TRC20, potresti non recuperare i tuoi asset digitali.",
    "tips4": "3. Assicurati che il tuo indirizzo e l'importo siano corretti prima della ricarica.",
    "tips5": "Avviso: a causa dell'anonimato e della riservatezza della rete blockchain, se inserisci informazioni errate, perderai gli asset corrispondenti. Assicurati di controllare attentamente il tuo indirizzo e la quantità di ricarica."
  },
  "tibi": {
    "title": "Prelievo",
    "tbjl": "Registro prelievi",
    "t1": "Indirizzo di prelievo",
    "t2": "Inserisci l'indirizzo di prelievo",
    "t3": "Quantità di prelievo",
    "qsrtbsl": "Inserisci la quantità di prelievo",
    "t4": "Minimo prelievo",
    "t5": "Password di trading",
    "t6": "Inserisci la password di trading",
    "t7": "Commissione",
    "t8": "Quantità accreditata",
    "t9": "Conferma",
    "sc": "Elimina",
    "bj": "Modifica",
    "bq": "Etichetta (Memo)",
    "qsrbq": "Inserisci etichetta",
    "yhktx": "Prelievo su conto bancario",
    "yhmc": "Nome della banca",
    "qsryhmc": "Inserisci il nome della banca",
    "yhzh": "Numero di conto bancario",
    "qsryhzh": "Inserisci il numero di conto bancario",
    "gjhkdm": "Codice di trasferimento internazionale",
    "qsrgjhkdm": "Inserisci il codice di trasferimento internazionale",
    "yhdz": "Indirizzo della banca",
    "qsryhdz": "Inserisci l'indirizzo della banca",
    "skrxm": "Nome del beneficiario",
    "qsrskrxm": "Inserisci il nome del beneficiario",
    "skrdh": "Telefono del beneficiario",
    "qsrskrdh": "Inserisci il telefono del beneficiario",
    "skrdz": "Indirizzo del beneficiario",
    "qsrskrdz": "Inserisci l'indirizzo del beneficiario"
  },
  "huazhuan": {
    "title": "Trasferimento USDT",
    "t1": "Saldo account di criptovaluta",
    "t2": "Saldo account di contratti",
    "t3": "Quantità da trasferire",
    "t4": "Inserisci la quantità",
    "t5": "Direzione del trasferimento",
    "t6": "Da",
    "t7": "Account di criptovaluta",
    "t8": "A",
    "t9": "Account di contratti",
    "t10": "Conferma",
    "zf": "Pagamento",
    "ky": "Disponibile",
    "dd": "Ricevi",
    "qbdh": "Scambia tutto"
  },
  "banner": {
    "title": "Dettagli"
  },
  "download": {
    "t1": "Trading mobile, in qualsiasi momento e ovunque",
    "xz": "Scarica"
  },

  "xgdlmm": {
    "title": "Modifica password di accesso",
    "zh": "Account",
    "zhts": "Numero di telefono o email",
    "yzm": "Codice di verifica",
    "yzmts": "Inserisci il codice di verifica",
    "hqyzm": "Ottieni codice di verifica",
    "mm": "Password",
    "mmts": "La password deve avere una lunghezza di 6-12 caratteri",
    "qrmm": "Conferma password",
    "send": "Invia",
    "qr": "Conferma"
  },
  "sztkmm": {
    "title": "Imposta password di trading",
    "dlmm": "Password di accesso",
    "dlmmts": "Inserisci la password di accesso",
    "xmm": "Nuova password",
    "mmts": "La password deve avere una lunghezza di 6 cifre",
    "qrmm": "Conferma password",
    "qr": "Conferma",
    "qd": "Conferma",
    "sztkts": "Avviso: Si prega di impostare la password di trading nel centro sicurezza"
  },
  "rule": {
    "title": "Regole dell'attività",
    "title2": "Regole",
    "title3": "Attività"
  },
  "news": {
    "title": "I miei messaggi",
    "ckxq": "Visualizza dettagli",
    "gg": "Annuncio"
  },
  "xsbk": {
    "title": "Da leggere per i principianti"
  },
 
"search": {
    "qx": "Annulla",
    "rmss": "Ricerca popolare",
    "ss": "Cerca"
  },
  "wdtg": {
    "title": "Riunione tra amici",
    "yq": "Invita",
    "zyj": "Guadagna commissioni",
    "wdyqlj": "Il mio link di invito",
    "wdyqm": "Il mio codice di invito",
    "schbyq": "Genera poster di invito",
    "ljtgsy": "Guadagni totali dalla promozione",
    "ljkh": "Clienti totali (persone)",
    "tkrs": "Numero di invitati",
    "ljyj": "Commissioni totali",
    "yjmx": "Dettagli commissioni",
    "ljyjjl": "Premi per commissioni totali (USDT)",
    "ljsy": "Guadagni totali",
    "ljyqjl": "Premi per inviti totali (USDT)",
    "fxd": "Condividi su",
    "wxhy": "Amici WeChat",
    "wxpyq": "Momenti WeChat",
    "bctp": "Salva immagine",
    "qx": "Annulla",
    "t1": "Estrai criptovalute mentre guadagni",
    "t2": "I profitti sono tutti tuoi",
    "t3": "Tieni premuto l'immagine per riconoscere o scansiona"
  },
  "bzhl": {
    "title": "Rimborso della posizione",
    "gz": "Regole",
    "tgdd": "Ordini in gestione",
    "zztgdzj": "Fondi in gestione",
    "yjjrsy": "Guadagni giornalieri stimati",
    "ljsy": "Guadagni totali",
    "tgzdd": "Ordini in gestione",
    "cljxcp": "Prodotti di investimento strategico",
    "dbxe": "Limite per transazione",
    "rsyl": "Tasso di rendimento giornaliero",
    "zq": "Ciclo",
    "qmr": "Acquista ora",
    "bbzhzc": "Asset del conto",
    "zcc": "Totale delle posizioni (USDT)",
    "dd": "Ordine",
    "buy": "Acquista",
    "jxcp": "Prodotti selezionati",
    "ckdd": "Visualizza ordini",
    "gd": "Di più",
    "xzbzts": "Semplice, sicuro. Puoi scegliere tra diverse valute per la distribuzione dei guadagni.",
    "qtbz": "Altre valute"
  },
  "bzhlgm": {
    "title": "Guadagno tramite arbitraggio",
    "bzhld": "Guadagno tramite arbitraggio in USDT",
    "qtzq": "Ciclo di 7 giorni USDT",
    "rsyl": "Tasso di rendimento (%)",
    "lczq": "Ciclo di investimento",
    "dbxe": "Limite per transazione",
    "pxsj": "Tempo di distribuzione",
    "mr": "Giornaliero",
    "dqfh": "Restituzione alla scadenza",
    "tgzj": "Fondi in gestione",
    "tqsh": "Riscatto",
    "yjsy": "Guadagno stimato (USDT)",
    "kyzc": "Asset disponibili (USDT)",
    "cpjs": "Introduzione al prodotto",
    "tgje": "Importo in gestione",
    "qsrtgje": "Inserisci l'importo in gestione",
    "qb": "Tutti",
    "rm": "Acquista ora",
    "cpzq": "Ciclo del prodotto",
    "jxr": "Giorno di calcolo degli interessi",
    "jiexr": "Giorno di regolazione degli interessi",
    "yjdzr": "Data di accredito prevista",
    "gz": "Comprendere le regole e i diritti"
  },
  "bzhlwdtg": {
    "title": "Stato dell'ordine",
    "tgz": "In gestione",
    "ywc": "Completato",
    "ysh": "Riscattato",
    "tgje": "Importo in gestione / Numero di giorni del ciclo",
    "rsyl": "Tasso di rendimento giornaliero",
    "yhl": "Guadagnato / Giorni rimanenti",
    "xdsj": "Tempo di ordinazione",
    "sh": "Riscatto",
    "ddxq": "Dettagli ordine",
    "ddh": "Numero d'ordine"
  },

 "bzjj": {
    "t1": "Guadagni quotidiani senza sosta",
    "t2": "L'arbitraggio avviene depositando USDT sulla piattaforma, con un team professionale che gestisce i diritti di arbitraggio. I partecipanti guadagnano una quota dei profitti durante il periodo di gestione dei fondi.",
    "cpld": "Punti salienti del prodotto",
    "scsq": "Deposito e prelievo a piacere",
    "pxzq": "Ciclo di distribuzione",
    "mtxf": "Distribuzione giornaliera",
    "hqlx": "Interessi a vista",
    "zj": "100% dei fondi",
    "aqbz": "Garanzia di sicurezza",
    "jjrsy": "Guadagni durante le festività",
    "sybjd": "Guadagni continui",
    "bjd": "Continuo",
    "cgcrh": "Dopo un deposito riuscito",
    "dtqx": "Interessi a partire da oggi",
    "jglz": "Facciamo un esempio",
    "syjs": "Calcolo dei guadagni",
    "cont1": "Un membro deposita 10.000U sulla piattaforma, scegliendo un ciclo di sette giorni con un tasso di rendimento giornaliero del 0,3%~0,5%, i guadagni giornalieri sono i seguenti:",
    "cont2": "Minimo: 10.000U × 0,3% - 30U",
    "cont3": "Massimo: 10.000U × 0,5% - 50U",
    "cont4": "Dopo 7 giorni, si possono ottenere guadagni tra 210U e 350U, i guadagni vengono distribuiti giornalmente e possono essere prelevati in qualsiasi momento, il capitale depositato viene restituito automaticamente al tuo wallet al termine del periodo.",
    "gywyj": "Informazioni sulle penali",
    "cont5": "Se desideri ritirare il capitale non scaduto, verrà applicata una penale, calcolata come: penale = percentuale di liquidazione * giorni rimanenti * importo investito.",
    "cont6": "Esempio: se la percentuale di liquidazione per questo prodotto è dello 0,4%, con 3 giorni rimanenti e un importo investito di 1000, la penale sarà: 0,4% * 3 * 1000 = 12U, il capitale effettivamente restituito sarà 1000U - 12U = 988U.",
    "wycy": "Voglio partecipare"
  },
  "zyzs": {
    "title": "Take profit e stop loss",
    "zy": "Take profit",
    "zs": "Stop loss",
    "qsrzyjg": "Inserisci il prezzo di take profit",
    "qsrzsjg": "Inserisci il prezzo di stop loss",
    "cfjglx": "Tipo di prezzo di attivazione:",
    "zsjg": "Prezzo indice",
    "scjg": "Prezzo di mercato",
    "pcfs": "Metodo di chiusura:",
    "kpcw": "Posizione chiudibile",
    "qbcw": "Tutta la posizione",
    "wxts": "Avviso:",
    "cont": "La chiusura di mercato potrebbe fallire a causa di forti fluttuazioni del mercato, rendendo impossibile il take profit o lo stop loss.",
    "qr": "Conferma"
  },
  "bbjy": {
    "mr": "Acquista",
    "mc": "Vendi",
    "mai": "Acquista",
    "sell": "Vendi",
    "xj": "Prezzo limite",
    "sj": "Prezzo di mercato",
    "pk": "Mercato",
    "jg": "Prezzo",
    "sl": "Quantità",
    "mrl": "Quantità da acquistare",
    "ss": "Quantità",
    "mcl": "Quantità da vendere",
    "ky": "Disponibile",
    "km": "Acquistabile",
    "ksell": "Vendibile",
    "jye": "Volume di trading",
    "dqwt": "Ordini attuali",
    "lswt": "Ordini storici",
    "jj": "Introduzione",
    "wtzl": "Volume totale degli ordini",
    "wtjg": "Prezzo dell'ordine",
    "ycjl": "Volume completato",
    "cjjj": "Prezzo medio di esecuzione",
    "cd": "Annulla ordine",
    "xd": "Fai ordine",
    "ywc": "Completato",
    "ycd": "Annullato",
    "wqcj": "Completamente completato",
    "zx": "Preferiti",
    "scjg": "Prezzo di mercato",
    "fhsj": "Data di emissione",
    "fhsl": "Quantità emessa",
    "bps": "Whitepaper",
    "gw": "Sito ufficiale",
    "qx": "Annulla"
  },
  "hyjy": {
    "mai": "Acquista",
    "sell": "Vendi",
    "kc": "Apertura posizione",
    "pc": "Chiusura posizione",
    "cc": "Posizione",
    "kp": "Chiudibile",
    "kpc": "Chiudibile short",
    "kcc": "Posizione aperta",
    "kkd": "Apertura long",
    "kpd": "Chiusura long",
    "kkk": "Apertura short",
    "xj": "Prezzo limite",
    "sj": "Prezzo di mercato",
    "xjwt": "Ordine a prezzo limite",
    "sjwt": "Ordine a prezzo di mercato",
    "pk": "Mercato",
    "jg": "Prezzo",
    "sl": "Quantità",
    "gg": "Leva",
    "tzgg": "Regola la leva",
    "ggbs": "Moltiplicatore della leva",
    "mrl": "Quantità da acquistare",
    "ky": "Disponibile",
    "jye": "Volume di trading",
    "dqwt": "Ordini attuali",
    "lswt": "Ordini storici",
    "ptwt": "Ordine normale",
    "dqwtmr": "Ordini attuali (acquisto)",
    "dqwtmc": "Ordini attuali (vendita)",
    "hywt": "Ordine di contratto",
    "jj": "Introduzione",
    "wtzl": "Volume totale degli ordini",
    "wtjg": "Prezzo dell'ordine",
    "ycjl": "Volume completato",
    "cjjj": "Prezzo medio di esecuzione",
    "cd": "Annulla ordine",
    "xd": "Fai ordine",
    "qbcd": "Annulla tutti gli ordini",
    "wqcj": "Completamente completato",
    "ywc": "Completato",
    "ycd": "Annullato",
    "zx": "Preferiti",
    "scjg": "Prezzo di mercato",
    "fhsj": "Data di emissione",
    "fhsl": "Quantità emessa",
    "bps": "Whitepaper",
    "gw": "Sito ufficiale",
    "mrzd": "Acquista long",
    "mrpk": "Acquista short",
    "mczk": "Vendi short",
    "mcpd": "Vendi long",
    "mrkdkz": "Acquista long (rialzista)",
    "mrpkkz": "Acquista short (rialzista)",
    "mckkkd": "Vendi short (ribassista)",
    "mcpdkd": "Vendi long (ribassista)",
    "yxhy": "Contratti perpetui",
    "dc": "Posizione long",
    "kcjj": "Prezzo medio di apertura (BUSDT)",
    "wsxyl": "Guadagni non realizzati (BUSDT)",
    "ygqpj": "Valutazione di liquidazione stimata (BUSDT)",
    "syl": "Tasso di rendimento",
    "cwbzj": "Margine di posizione (BUSDT)",
    "cw": "Posizione (contratti)",
    "cwjz": "Valore della posizione (BUSDT)",
    "bzjl": "Tasso di margine",
    "kpz": "Posizioni chiudibili (contratti)",
    "bdzs": "Indice sottostante",
    "tzbzj": "Regola il margine",
    "zyzs": "Take profit e stop loss",
    "zjbzj": "Aumenta il margine",
    "jsbzj": "Diminuisci il margine",
    "tyhy": "Prova il contratto",
    "ccz": "Posizione (contratti)",
    "cwbzjt": "Margine di posizione (TBTC)",
    "zdzjbzj": "Massimo aumento del margine (TBTC)",
    "zjbzjt": "Aumenta il margine (TBTC)",
    "zhang": "Quantità",
    "qblx": "Tutti i tipi",
    "qb": "Tutti",
    "ccjg": "Prezzo della posizione",
    "ccsl": "Quantità della posizione",
    "yk": "Guadagno/perdita",
    "ccsj": "Tempo di posizione",
    "zy": "Take profit",
    "zs": "Stop loss",
    "zje": "Importo totale",
    "kcs": "Numero di aperture",
    "kcjg": "Prezzo di apertura",
    "ss": "Mani",
    "hand": "1 mano =",
    "qx": "Annulla",
    "qr": "Conferma"
  },

 "kxt": {
    "gao": "Alto",
    "di": "Basso",
    "wtgd": "Ordini in sospeso",
    "cj": "Completato",
    "jj": "Introduzione",
    "sj": "Tempo",
    "fx": "Direzione",
    "jg": "Prezzo",
    "sl": "Quantità",
    "mr": "Acquista",
    "mc": "Vendi",
    "mp": "Acquisto",
    "sp": "Vendita",
    "slb": "Quantità",
    "fhsj": "Data di emissione",
    "fhsl": "Quantità emessa",
    "bps": "Whitepaper",
    "gw": "Sito ufficiale",
    "fz": "min",
    "xs": "ora",
    "tian": "giorno",
    "zhou": "settimana",
    "yue": "mese",
    "gd": "Di più",
    "ft": "Grafico secondario",
    "zt": "Grafico principale",
    "sdt": "Grafico di profondità",
    "zx": "Preferiti",
    "djck": "Clicca per visualizzare"
  },
  "zhjl": {
    "cbtb": "Ricarica e prelievo",
    "jymx": "Dettagli delle transazioni",
    "tgyj": "Commissioni promozionali",
    "wwc": "Non completato",
    "ywc": "Completato"
  },
  "zwsj": {
    "title": "Nessun dato disponibile"
  },
  "bzxz": {
    "title": "Seleziona tipo di valuta"
  },
  "jghy": {
    "jghy": "Contratti di consegna",
    "yxhy": "Contratti perpetui",
    "mz": "Acquista in aumento",
    "md": "Acquista in diminuzione",
    "gmj": "Prezzo di acquisto",
    "jsj": "Prezzo di regolazione",
    "xj": "Prezzo attuale",
    "fx": "Direzione",
    "sl": "Quantità",
    "jgsj": "Tempo di consegna",
    "gb": "Chiudi",
    "jxxd": "Continua a ordinare",
    "cclb": "Lista delle posizioni",
    "zc": "In possesso",
    "lscc": "Posizioni storiche",
    "qblx": "Tutti i tipi",
    "yk": "Guadagno/perdita",
    "ddqr": "Conferma ordine",
    "dqsj": "Data di scadenza",
    "jssj": "Tempo di regolazione",
    "sy": "Guadagni",
    "tzje": "Importo dell'investimento",
    "zdje": "L'importo dell'investimento deve essere maggiore di 0",
    "kyye": "Saldo disponibile:",
    "kyye2": "Saldo disponibile",
    "sxf": "Commissione:",
    "sxfl": "Commissione",
    "jypz": "Nome",
    "jyfx": "Direzione della transazione",
    "qrxd": "Conferma ordine",
    "fs": "Di più",
    "dqye": "Saldo attuale"
  },

 "kjmb": {
    "title": "Acquisto rapido di criptovalute",
    "gm": "Acquista USDT",
    "wxts": "Avviso:",
    "wxts-copy": "Si prega di copiare l'indirizzo USDT, è necessario utilizzare questo indirizzo per acquistare USDT.",
    "copy": "Copia",
    "ljmb": "Acquista subito",
    "buy": "Acquista",
    "cs": "Vendi",
    "qx": "Annulla",
    "gmsl": "Quantità da acquistare",
    "cssl": "Quantità da vendere",
    "qsrgmsl": "Inserisci la quantità da acquistare",
    "qsrcssl": "Inserisci la quantità da vendere",
    "qxzzffs": "Seleziona il metodo di pagamento",
    "yhk": "Conto bancario",
    "wx": "WeChat",
    "zfb": "Alipay",
    "jg": "Prezzo",
    "kyye": "Saldo disponibile:",
    "zxjysl": "Quantità minima di transazione:",
    "ts1": "1. I venditori sono commercianti certificati dalla piattaforma, offrono assistenza 24 ore su 24.",
    "ts2": "2. In caso di controversie sugli ordini, contattare immediatamente il servizio clienti per risolvere.",
    "fzcg": "Copia riuscita"
  },
  "tips": {
    "jymm": "Password di trading",
    "szjymm": "Imposta la password di trading",
    "qsrjymm": "Inserisci la password di trading",
    "jymmts": "Si prega di impostare la password di trading nel centro sicurezza"
  },
  "xyf": {
    "title": "Punti di credito",
    "pgsj": "Tempo di valutazione"
  },
  "dzrz": {
    "title": "Verifica indirizzo",
    "sdddz": "Indirizzo della bolletta",
    "tips": "Devi compilare le informazioni sull'indirizzo e inviare la bolletta dell'acqua o dell'elettricità.",
    "tpsc": "Caricamento immagine della bolletta",
    "ts": "Avviso: Devi compilare le informazioni sull'indirizzo e inviare la bolletta dell'acqua o dell'elettricità.",
    "qsczdtp": "Si prega di caricare l'immagine della bolletta"
  },
  "newReg": {
    "sjh": "Numero di telefono",
    "yx": "Email",
    "yqm": "Codice di invito",
    "yqm2": "Codice di invito (facoltativo)",
    "cjzh": "Crea account",
    "sysjhzyx": "Registrati utilizzando numero di telefono/email",
    "sj": "Telefono",
    "yhxy": "《Accordo utente》",
    "yhxy2": "Ho letto e accetto 《Accordo utente》"
  },
  "mbwt": {
    "title": "Impostazione delle domande di sicurezza",
    "mbwt": "Domande di sicurezza",
    "qtxda": "Inserisci la risposta",
    "qsrxmm": "Inserisci la nuova password",
    "sydqmmcz": "Reimposta utilizzando la password attuale",
    "zhmm": "Recupero della password tramite domanda di sicurezza",
    "ysz": "Già impostato",
    "tg": "Salta",
    "tj": "Invia",
    "zyts": "Avviso importante:",
    "zytsCont": "Non divulgare le risposte alle domande di sicurezza e i codici di verifica, e ricorda le domande di sicurezza, questo ti aiuterà a recuperare la password."
  },
  "xbsg": {
    "title": "Richiesta di nuovi asset",
    "wdsg": "Le mie richieste",
    "scts": "Giorni di blocco:",
    "sy": "Rimanente",
    "ljsg": "Richiesta immediata",
    "ysk": "Esaurito",
    "xzjdy": "Iscriviti ora",
    "dy": "Iscrizione",
    "fxjg": "Prezzo di emissione",
    "fxl": "Quantità emessa",
    "ssrq": "Data di quotazione",
    "yxqx": "Scadenza",
    "qsrsl": "Inserisci la quantità",
    "syl": "Quantità rimanente",
    "sgrq": "Data di richiesta",
    "sgsl": "Quantità richiesta",
    "bz": "Tipo di valuta",
    "yebz": "Saldo USDT insufficiente",
    "tgsl": "Quantità di approvazione",
    "shz": "In revisione",
    "wtg": "Non approvato",
    "ytg": "Approvato"
  },

 "wydb": {
    "title": "Voglio prestiti",
    "db": "Prestiti",
    "dbz": "In prestito",
    "jl": "Registro",
    "jdzq": "Periodo di prestito (giorni)",
    "qhk": "Rimborso",
    "ljdb": "Prestito totale (USDT)",
    "dhkbs": "Numero di prestiti in attesa",
    "jkje": "Importo del prestito (USDT)",
    "qsrje": "Inserisci l'importo",
    "rll": "Tasso di interesse giornaliero",
    "hkfs": "Metodo di rimborso",
    "dqych": "Rimborso in un'unica soluzione alla scadenza",
    "lx": "Interessi",
    "fkjg": "Istituto di prestito",
    "tpsc": "Prestito personale (caricamento immagini)",
    "fwxx": "Informazioni sulla proprietà",
    "srzm": "Prova di reddito (rapporto di lavoro)",
    "yhmx": "Dettagli bancari",
    "zjz": "Foto del documento",
    "yd": "Ho letto e accetto",
    "xy": "Accordo di prestito",
    "sqdb": "Clicca per richiedere un prestito",
    "gb": "Chiudi",
    "qd": "Conferma",
    "ts": "Seleziona l'accordo di prestito",
    "dbjl": "Registro prestiti",
    "hkhth": "Numero di contratto di prestito",
    "wsh": "Non revisato",
    "yfk": "Prestato",
    "sqrq": "Data di richiesta",
    "zq": "Periodo",
    "dbsl": "Quantità di prestito",
    "zhke": "Importo totale da rimborsare",
    "yhkxq": "Dettagli del rimborso",
    "bqyhk": "Importo da rimborsare (USDT)",
    "hktips": "Assicurati che il saldo sia sufficiente, se il saldo è insufficiente, ricarica prima di rimborsare.",
    "bj": "Capitale",
    "jie": "Prestare",
    "ljhk": "Rimborso immediato",
    "qcz": "Ricarica",
    "yebzqxcz": "Saldo insufficiente, ricarica prima di rimborsare.",
    "znj": "Penale per ritardo",
    "yqts": "Giorni di ritardo"
  },
  "hkxq": {
    "dd": "Ordine",
    "fzhkdz": "Copia indirizzo di rimborso",
    "hkxq": "Dettagli rimborso",
    "zlx": "Interessi totali",
    "zhk": "Rimborso totale",
    "hkjg": "Istituto di rimborso",
    "qschkpz": "Si prega di caricare la ricevuta di rimborso",
    "hkpz": "Ricevuta di rimborso"
  },
  "bbjyNew": {
    "jylx": "Tipo di transazione",
    "jyze": "Importo totale della transazione"
  },
  "indexNew": {
    "title": "Aggiungi TokenSwap alla schermata principale",
    "t1": "Accesso rapido, esperienza a schermo intero",
    "t2": "Clicca sulla barra degli strumenti qui sotto",
    "t3": "e seleziona",
    "t4": "Aggiungi alla schermata principale",
    "t5": "Aggiungi TokenSwap alla tua esperienza completa sul desktop",
    "t6": "Aggiungi ai preferiti",
    "t7": "Cerca nella pagina"
  },
  "bind": {
    "title": "Verifica email",
    "ybd": "Già collegata",
    "wbd": "Non collegata",
    "yrz": "Già verificata",
    "wrz": "Non verificata",
    "ts": "Per proteggere il tuo account, ti consigliamo di collegare un'email",
    "qsryxdz": "Inserisci l'indirizzo email"
  },
  "status": {
    "statusText": ["Fallito", "In attesa di elaborazione", "Successo"]
  },
  "tipsNew": {
    "wjmmts": "Recupera la password tramite codice di verifica",
    "qscpztp": "Si prega di caricare l'immagine della ricevuta",
    "emailgsts": "L'email inserita non è valida",
    "telgsts": "Il formato del numero di telefono inserito è errato",
    "lcmmbyz": "Le due password inserite non corrispondono",
    "zdsl": "Quantità minima",
    "sldydy": "La quantità deve essere maggiore o uguale a",
    "zxtzsl": "Quantità minima",
    "ddz": "In attesa",
    "xs": "Ore",
    "min": "Quantità minima",
    "max": "Quantità massima",
    "yebz": "Saldo insufficiente",
    "qsrss": "Inserisci il numero di mani",
    "zdss": "Numero minimo di mani",
    "yjj": "Rifiutato",
    "shz": "In fase di riscatto",
    "zwkfcz": "Questo tipo di valuta non è ancora disponibile per la ricarica",
    "jiaoge": "Consegna",
    "zhang": "Aumento",
    "die": "Diminuzione",
    "cjxnzh": "Crea un account virtuale"
  },
  "langNew2": {
    "flzq": "Area di benefici",
    "qdjl": "Ricompense per check-in",
    "mrqdjl": "Ricompense giornaliere per check-in",
    "qd": "Check-in",
    "yqd": "Già effettuato il check-in",
    "hdgz": "Regole dell'attività",
    "qdjl2": "Registro check-in",
    "qdcg": "Check-in riuscito",
    "yhd": "Già ottenuto",
    "lq": "Ricevi",
    "dyt": "Primo giorno",
    "det": "Secondo giorno",
    "dst": "Terzo giorno",
    "dsit": "Quarto giorno",
    "dwt": "Quinto giorno",
    "dlt": "Sesto giorno",
    "dqt": "Settimo giorno",
    "jxz": "In corso"
  },
  "langNew": {
    "kp": "Apertura",
    "zuoshou": "Chiusura precedente",
    "zg": "Massimo",
    "zd": "Minimo",
    "dqjg": "Prezzo attuale",
    "pcjg": "Prezzo di chiusura",
    "gd": "Ordine in sospeso",
    "gdj": "Prezzo dell'ordine in sospeso",
    "gdjg": "Prezzo dell'ordine in sospeso",
    "xfbzj": "Margine richiesto:",
    "ksrfw": "Intervallo di input disponibile:",
    "shou": "Mani",
    "fdjyk": "Guadagno netto fluttuante",
    "pcsl": "Quantità di chiusura",
    "cx": "Annulla",
    "qrpc": "Conferma chiusura",
    "sx": "Filtra",
    "cz": "Reimposta",
    "zdl": "Capito",
    "kccg": "Apertura riuscita!",
    "xzfx": "Seleziona direzione",
    "lx": "Tipo",
    "xgcc": "Modifica posizione",
    "szzyzs": "Imposta take profit e stop loss",
    "szhb": "Valuta digitale",
    "gjs": "Metalli preziosi",
    "yy": "Petrolio",
    "jy": "Trading",
    "jmhb": "Criptovalute",
    "gdsj": "Tempo di ordine in sospeso",
    "gdsl": "Quantità in sospeso",
    "fs": "tempo"
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/it.js